/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import WrapperContent from './WrapperContent';
import {formatDate} from '../../modules/utils';
import CurrencyFormat from 'react-currency-format';
import {useDispatch, useSelector} from 'react-redux';
import {Table} from 'antd';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import {
  SELECTOR_BALANCE,
  SELECTOR_BALANCE2,
  SELECTOR_BALANCE3,
  SELECTOR_CUSTOM_PAYMENTS,
  SELECTOR_E_WALLET,
  SELECTOR_E_WALLET_PAGINATION,
} from '../../redux/selectors/eWallet';
import {
  getCustomPayments,
  getEWallet,
  getTotalEWallet,
} from '../../redux/actions/eWallet';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import MaskedInput from 'react-text-mask';
import TextField from '@material-ui/core/TextField';
import AppButton from '../../components/AppButton';
import CheckoutPay from '../CheckoutPay';

const numberMask = createNumberMask({prefix: '$'});
const NumberMaskIput = React.forwardRef((props, ref) => {
  return <MaskedInput ref={ref} mask={numberMask} {...props} />;
});

const columns = [
  {
    title: 'Factura No..',
    dataIndex: 'Numero',
    sorter: false,
  },
  {
    title: 'Fecha de vencimiento',
    dataIndex: 'Vencimiento',
    sorter: false,
    render: (date) => <span>{formatDate(date)}</span>,
  },
  {
    title: 'Valor total',
    dataIndex: 'Valor_total',
    render: (price) => (
      <CurrencyFormat
        value={price}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        renderText={(value) => <span>{value}</span>}
      />
    ),
  },
  {
    title: 'Saldo',
    dataIndex: 'Saldo',
    render: (price) => (
      <CurrencyFormat
        value={price}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        renderText={(value) => <span>{value}</span>}
      />
    ),
  },
];

const customPaymentColumns = [
  {
    title: 'ID del pago',
    dataIndex: 'id',
    sorter: false,
  },
  {
    title: 'Valor',
    dataIndex: 'amount',
    render: (price) => (
      <CurrencyFormat
        value={price}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        renderText={(value) => <span>{value}</span>}
      />
    ),
  },
  {
    title: 'Estado',
    dataIndex: 'status',
    render: () => 'Pagado',
  },
  {
    title: 'Metodo de pago',
    dataIndex: 'method',
    render: (v) => (v === 'credit_card' ? 'Targeta de credito' : 'PSE'),
  },
  {
    title: 'Fecha de pago',
    dataIndex: 'createdAt',
    render: (v) => moment(v).format('DD/MM/YYYY'),
  },
];

const Wallet = () => {
  const balance = useSelector(SELECTOR_BALANCE);
  const balance2 = useSelector(SELECTOR_BALANCE2);
  const balance3 = useSelector(SELECTOR_BALANCE3);
  const listEWallet = useSelector(SELECTOR_E_WALLET);
  const listEWalletPagination = useSelector(SELECTOR_E_WALLET_PAGINATION);
  const listCustomPayments = useSelector(SELECTOR_CUSTOM_PAYMENTS);
  const user = useSelector((state) => state.auth.user);

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState('');
  const [openPayModal, setOpenPayModal] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    if (user.id) {
      fetch();
    }
  }, [user.id]);

  const fetch = async () => {
    setLoading(true);
    try {
      await dispatch(getTotalEWallet());
      await dispatch(getEWallet());
      await dispatch(getCustomPayments());
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = () => {};

  return (
    <WrapperContent>
      <Box mt={3}>
        <Typography display={'inline'} variant="body2">
          Saldo total:&nbsp;
        </Typography>
        <Typography display={'inline'}>
          ${numeral(balance).format('0,0')}
        </Typography>
      </Box>
      <Box mt={1}>
        <Typography display={'inline'} variant="body2">
          Pagos pendientes por aplicar:&nbsp;
        </Typography>
        <Typography display={'inline'}>
          ${numeral(balance2).format('0,0')}
        </Typography>
      </Box>
      <Box mt={1} mb={2}>
        <Typography display={'inline'} variant="body2">
          Saldo total - Pagos pendientes por aplicar:&nbsp;
        </Typography>
        <Typography display={'inline'}>
          ${numeral(balance3).format('0,0')}
        </Typography>
      </Box>
      <Divider />
      <Box mt={3} mb={2}>
        <div>
          <Typography variant="body2">¿Cuánto deseas abonar?</Typography>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <Box mr={3}>
              <TextField
                name="expiry"
                margin="dense"
                variant="outlined"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                InputProps={{
                  inputComponent: NumberMaskIput,
                }}
              />
            </Box>
            <CheckoutPay
              open={openPayModal}
              handleClose={() => setOpenPayModal(false)}
              value={value}
            />
            <AppButton
              round
              disableElevation
              size="large"
              color="secondary"
              variant="contained"
              onClick={() => setOpenPayModal(true)}
              loading={loading}
              {...(loading || value === '' ? {disabled: true} : {})}
            >
              Pagar ahora
            </AppButton>
          </div>
        </div>
      </Box>
      <Box mt={3} mb={2}>
        <Typography variant="body2">
          Abonos a cartera pendiente por aplicar.
        </Typography>
        <Typography variant={'caption'}>
          *Solo se mustran los abonos realizados por la página web que aún no
          han sido aplicados.*
        </Typography>
      </Box>
      <Box mt={3} mb={2}>
        <Table
          columns={customPaymentColumns}
          rowKey={(item) => item.id}
          dataSource={listCustomPayments}
          pagination={false}
          loading={loading}
          onChange={handleTableChange}
        />
      </Box>
      <Box mt={3} mb={2}>
        <Typography variant="body2">Cartera actual.</Typography>
      </Box>
      <Box mt={3} mb={5}>
        <Table
          columns={columns}
          rowKey={(item) => item.id}
          dataSource={listEWallet}
          pagination={listEWalletPagination}
          loading={loading}
          onChange={handleTableChange}
        />
      </Box>
    </WrapperContent>
  );
};

export default Wallet;
